module.exports = __webpack_public_path__ + "75db5319e7e87c587019a5df08d7272c.woff2";